import ListView from "./ListView/ListView";

const HistoryPks = () => <p>HistoryPks</p>;

HistoryPks.ListView = ListView;
export default HistoryPks;
